export default __webpack_public_path__ + "static/media/to-test.5f3f13e6.svg";